import { TriggerAction } from './types';

export function isTriggerAction(
  action: unknown,
  actionFilters: TriggerAction[],
) {
  return actionFilters.some(filter => {
    if (typeof filter === 'string') {
      return (
        typeof action === 'object' &&
        action !== null &&
        'type' in action &&
        (action as { type: string }).type === filter
      );
    }

    return filter(action);
  });
}
